import { Message } from '@studio/design-system/prompt';
import type { Device } from '@studio/models/device';
import type { ReactElement } from 'react';
import type { Named } from '#~/models/index.js';

/** @internal */
export const DeleteMessage = (props: { device: Named<Device> }): ReactElement => (
  <Message>
    Are you sure you want to delete the source
    <br />
    <strong>&ldquo;{props.device.name}&rdquo;</strong>?
  </Message>
);
